import { loadResults } from "../../Viewer/Results/LoadResults";


export function loadResult(){
    $(".preloader").show();
    const submissionId = $("#submission-id").val()
    loadResults(submissionId)
}